/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ImageBox.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { GetSingleImages } from "../../../redux/actions/actionHandler";
function ImageBox({ boxes, sx = {} }) {
  const [image, setImage] = useState("");
  useEffect(() => {
    if (boxes?.vehicle_class_details && boxes?.vehicle_class_details?.length) {
      const fetchImage = async () => {
        try {
          const imageDetails = { image: boxes.vehicle_class_details[0].image };
          const resp = await GetSingleImages(imageDetails);

          setImage(resp); // Update state with the fetched image
        } catch (error) { }
      };

      fetchImage();
    }
  }, [boxes?.vehicle_class_details[0].image]);
  return (
    <Box
      sx={{
        width: 72,
        height: 72,
        borderRadius: 1,
        overflow: "hidden",
        ...sx,
      }}
    >
      <img
        alt=""
        src={image}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </Box>
  );
}

export default ImageBox;

const styled = {
  imgBox: { width: "72px", height: "72px" },
};
